import { vocabularyConstants } from '../../constants';
import { vocabularyService } from '../../services';
import { notificationActions } from './notification.actions';

const getAll = (params: { page: number; limit: number; search?: string; level?: string; grade?: string; is_ielts?: string; is_toeic?: string }) => {
  return async (dispatch: any) => {
    const request = () => ({ type: vocabularyConstants.GETALL_REQUEST });
    const success = (data: any) => ({ type: vocabularyConstants.GETALL_SUCCESS, payload: data });
    const failure = (error: any) => ({ type: vocabularyConstants.GETALL_FAILURE, payload: error });

    dispatch(request());

    try {
      const data = await vocabularyService.getAll(params);
      dispatch(success(data));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const getStats = () => {
  return async (dispatch: any) => {
    const request = () => ({ type: vocabularyConstants.GET_STATS_REQUEST });
    const success = (data: any) => ({ type: vocabularyConstants.GET_STATS_SUCCESS, payload: data });
    const failure = (error: any) => ({ type: vocabularyConstants.GET_STATS_FAILURE, payload: error });

    dispatch(request());

    try {
      const data = await vocabularyService.getStats();
      dispatch(success(data));
    } catch (error: any) {
      dispatch(failure(error.toString()));
    }
  };
};

const createVocabulary = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(formData));

    try {
      const vocabulary = await vocabularyService.create(formData);
      dispatch(success(vocabulary));
      return vocabulary;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request(vocabulary: any) {
    return { type: vocabularyConstants.CREATE_REQUEST, payload: vocabulary };
  }
  function success(vocabulary: any) {
    return { type: vocabularyConstants.CREATE_SUCCESS, payload: vocabulary };
  }
  function failure(error: any) {
    return { type: vocabularyConstants.CREATE_FAILURE, error };
  }
};

const updateVocabulary = (id: number, formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(id));

    try {
      const vocabulary = await vocabularyService.update(id, formData);
      dispatch(success(vocabulary));
      dispatch(notificationActions.addNotification('Cập nhật từ vựng thành công!', 'SUCCESS'));
      return vocabulary;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request(id: number) {
    return { type: vocabularyConstants.UPDATE_REQUEST, payload: id };
  }
  function success(vocabulary: any) {
    return { type: vocabularyConstants.UPDATE_SUCCESS, payload: vocabulary };
  }
  function failure(error: any) {
    return { type: vocabularyConstants.UPDATE_FAILURE, error };
  }
};

const deleteVocabulary = (id: number) => {
  return async (dispatch: any) => {
    dispatch(request(id));

    try {
      await vocabularyService.remove(id);
      dispatch(success(id));
      dispatch(notificationActions.addNotification('Xóa từ vựng thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request(id: number) {
    return { type: vocabularyConstants.DELETE_REQUEST, payload: id };
  }
  function success(id: number) {
    return { type: vocabularyConstants.DELETE_SUCCESS, payload: id };
  }
  function failure(error: any) {
    return { type: vocabularyConstants.DELETE_FAILURE, error };
  }
};

const searchVocabulary = (query: string) => {
  return async (dispatch: any) => {
    const request = () => ({ type: vocabularyConstants.SEARCH_REQUEST });
    const success = (data: any) => ({ type: vocabularyConstants.SEARCH_SUCCESS, payload: data });
    const failure = (error: any) => ({ type: vocabularyConstants.SEARCH_FAILURE, payload: error });

    dispatch(request());

    try {
      const data = await vocabularyService.search(query);
      dispatch(success(data));
    } catch (error: any) {
      dispatch(failure(error.toString()));
    }
  };
};

export const vocabularyActions = {
  getAll,
  getStats,
  createVocabulary,
  updateVocabulary,
  deleteVocabulary,
  searchVocabulary,
};
